// extracted by mini-css-extract-plugin
module.exports = {"sportFeed":"SportFeed_sportFeed__1ZtZq","title":"SportFeed_title__WjN9p","active":"SportFeed_active__2xzW4"};